Object.defineProperty(exports, "__esModule", {
    value: true
});
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var require_constant = require('./constant.cjs');
//#region src/generateSnapshotFromManifest.ts
var simpleJoinRemoteEntry = (rPath, rName)=>{
    if (!rPath) return rName;
    var transformPath = (str)=>{
        if (str === ".") return "";
        if (str.startsWith("./")) return str.replace("./", "");
        if (str.startsWith("/")) {
            var strWithoutSlash = str.slice(1);
            if (strWithoutSlash.endsWith("/")) return strWithoutSlash.slice(0, -1);
            return strWithoutSlash;
        }
        return str;
    };
    var transformedPath = transformPath(rPath);
    if (!transformedPath) return rName;
    if (transformedPath.endsWith("/")) return `${transformedPath}${rName}`;
    return `${transformedPath}/${rName}`;
};
function inferAutoPublicPath(url) {
    return url.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
}
function generateSnapshotFromManifest(manifest) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _manifest_remotes, _manifest_metaData, _manifest_metaData1;
    var _options_remotes = options.remotes, remotes = _options_remotes === void 0 ? {} : _options_remotes, _options_overrides = options.overrides, overrides = _options_overrides === void 0 ? {} : _options_overrides, version = options.version;
    var remoteSnapshot;
    var getPublicPath = ()=>{
        if ("publicPath" in manifest.metaData) {
            if ((manifest.metaData.publicPath === "auto" || manifest.metaData.publicPath === "") && version) return inferAutoPublicPath(version);
            return manifest.metaData.publicPath;
        } else return manifest.metaData.getPublicPath;
    };
    var overridesKeys = Object.keys(overrides);
    var remotesInfo = {};
    if (!Object.keys(remotes).length) remotesInfo = ((_manifest_remotes = manifest.remotes) === null || _manifest_remotes === void 0 ? void 0 : _manifest_remotes.reduce((res, next)=>{
        var matchedVersion;
        var name = next.federationContainerName;
        if (overridesKeys.includes(name)) matchedVersion = overrides[name];
        else if ("version" in next) matchedVersion = next.version;
        else matchedVersion = next.entry;
        res[name] = {
            matchedVersion
        };
        return res;
    }, {})) || {};
    Object.keys(remotes).forEach((key)=>remotesInfo[key] = {
            matchedVersion: overridesKeys.includes(key) ? overrides[key] : remotes[key]
        });
    var _manifest_metaData2 = manifest.metaData, _manifest_metaData_remoteEntry = _manifest_metaData2.remoteEntry, remoteEntryPath = _manifest_metaData_remoteEntry.path, remoteEntryName = _manifest_metaData_remoteEntry.name, remoteEntryType = _manifest_metaData_remoteEntry.type, tmp = _manifest_metaData2.types, remoteTypes = tmp === void 0 ? {
        path: "",
        name: "",
        zip: "",
        api: ""
    } : tmp, buildVersion = _manifest_metaData2.buildInfo.buildVersion, globalName = _manifest_metaData2.globalName, ssrRemoteEntry = _manifest_metaData2.ssrRemoteEntry;
    var exposes = manifest.exposes;
    var basicRemoteSnapshot = {
        version: version ? version : "",
        buildVersion,
        globalName,
        remoteEntry: simpleJoinRemoteEntry(remoteEntryPath, remoteEntryName),
        remoteEntryType,
        remoteTypes: simpleJoinRemoteEntry(remoteTypes.path, remoteTypes.name),
        remoteTypesZip: remoteTypes.zip || "",
        remoteTypesAPI: remoteTypes.api || "",
        remotesInfo,
        shared: manifest === null || manifest === void 0 ? void 0 : manifest.shared.map((item)=>({
                assets: item.assets,
                sharedName: item.name,
                version: item.version,
                usedExports: item.referenceExports || []
            })),
        modules: exposes === null || exposes === void 0 ? void 0 : exposes.map((expose)=>({
                moduleName: expose.name,
                modulePath: expose.path,
                assets: expose.assets
            }))
    };
    if ((_manifest_metaData = manifest.metaData) === null || _manifest_metaData === void 0 ? void 0 : _manifest_metaData.prefetchInterface) {
        var prefetchInterface = manifest.metaData.prefetchInterface;
        basicRemoteSnapshot = _object_spread_props._(_object_spread._({}, basicRemoteSnapshot), {
            prefetchInterface
        });
    }
    if ((_manifest_metaData1 = manifest.metaData) === null || _manifest_metaData1 === void 0 ? void 0 : _manifest_metaData1.prefetchEntry) {
        var _manifest_metaData_prefetchEntry = manifest.metaData.prefetchEntry, path = _manifest_metaData_prefetchEntry.path, name = _manifest_metaData_prefetchEntry.name, type = _manifest_metaData_prefetchEntry.type;
        basicRemoteSnapshot = _object_spread_props._(_object_spread._({}, basicRemoteSnapshot), {
            prefetchEntry: simpleJoinRemoteEntry(path, name),
            prefetchEntryType: type
        });
    }
    if ("publicPath" in manifest.metaData) {
        remoteSnapshot = _object_spread_props._(_object_spread._({}, basicRemoteSnapshot), {
            publicPath: getPublicPath()
        });
        if (typeof manifest.metaData.ssrPublicPath === "string") remoteSnapshot.ssrPublicPath = manifest.metaData.ssrPublicPath;
    } else remoteSnapshot = _object_spread_props._(_object_spread._({}, basicRemoteSnapshot), {
        getPublicPath: getPublicPath()
    });
    if (ssrRemoteEntry) {
        var fullSSRRemoteEntry = simpleJoinRemoteEntry(ssrRemoteEntry.path, ssrRemoteEntry.name);
        remoteSnapshot.ssrRemoteEntry = fullSSRRemoteEntry;
        remoteSnapshot.ssrRemoteEntryType = ssrRemoteEntry.type || "commonjs-module";
    }
    return remoteSnapshot;
}
function isManifestProvider(moduleInfo) {
    if ("remoteEntry" in moduleInfo && moduleInfo.remoteEntry.includes(require_constant.MANIFEST_EXT)) return true;
    else return false;
}
function getManifestFileName(manifestOptions) {
    if (!manifestOptions) return {
        statsFileName: require_constant.StatsFileName,
        manifestFileName: require_constant.ManifestFileName
    };
    var filePath = typeof manifestOptions === "boolean" ? "" : manifestOptions.filePath || "";
    var fileName = typeof manifestOptions === "boolean" ? "" : manifestOptions.fileName || "";
    var JSON_EXT = ".json";
    var addExt = (name)=>{
        if (name.endsWith(JSON_EXT)) return name;
        return `${name}${JSON_EXT}`;
    };
    var insertSuffix = (name, suffix)=>{
        return name.replace(JSON_EXT, `${suffix}${JSON_EXT}`);
    };
    var manifestFileName = fileName ? addExt(fileName) : require_constant.ManifestFileName;
    return {
        statsFileName: simpleJoinRemoteEntry(filePath, fileName ? insertSuffix(manifestFileName, "-stats") : require_constant.StatsFileName),
        manifestFileName: simpleJoinRemoteEntry(filePath, manifestFileName)
    };
}
//#endregion
exports.generateSnapshotFromManifest = generateSnapshotFromManifest;
exports.getManifestFileName = getManifestFileName;
exports.inferAutoPublicPath = inferAutoPublicPath;
exports.isManifestProvider = isManifestProvider;
exports.simpleJoinRemoteEntry = simpleJoinRemoteEntry; //# sourceMappingURL=generateSnapshotFromManifest.cjs.map
